import * as actionTypes from 'actions';
import { ENTITY_TYPES } from 'common/constants';

const initialState = {
  saved: false,
  savedVenue: {},
  deleted: false,
  deletedVenue: {},
  venue: {
    creationId: null,
    name: '',
    shortCode: '',
    phoneNumber: '',
    emailAddress: '',
    address: '',
    capacity: '',
    type: null,
    description: '',
    latitude: '',
    longitude: '',
    cellHealthRadarThreshold: '',
    cellHealthMagnetometerThreshold: '',
    authorizedPortalEmailDomains: [],
    integrationPartnerIdentifiers: []
  },
  entityPhotos: [],
  customers: [],
  validationMessages: {},
  saving: false
};

const venueCreateReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SAVE_VENUE_PENDING: {
      return {
        ...state,
        saving: true
      };
    }

    case actionTypes.SAVE_VENUE_FULFILLED: {
      return {
        ...state,
        saved: action.payload.data.success,
        savedVenue: action.payload.data.result,
        validationMessages: action.payload.data.validationMessages,
        saving: false
      };
    }

    case actionTypes.DELETE_VENUE_FULFILLED: {
      return {
        ...state,
        deleted: action.payload.data.success,
        deletedVenue: action.payload.data.result
      };
    }

    case actionTypes.EDIT_VENUE_FULFILLED: {
      return {
        ...state,
        venue: {
          ...action.payload.data.result,
          identifiersCreated: true
        }
      };
    }

    case actionTypes.CREATE_VENUE_VALUE_RESET: {
      return {
        ...initialState
      };
    }

    case actionTypes.CREATE_VENUE_VALUE_UPDATE: {
      return {
        ...state,
        venue: {
          ...state.venue,
          ...action.payload
        }
      };
    }

    case actionTypes.FIND_CUSTOMERS_PENDING: {
      return {
        ...state,
        customers: initialState.customers
      };
    }

    case actionTypes.FIND_CUSTOMERS_FULFILLED: {
      return {
        ...state,
        customers: action.payload.data
      };
    }

    case actionTypes.CREATE_ENTITY_PHOTO_FULFILLED: {
      const entityPhoto = action.payload.data.result;
      let result;

      if (
        entityPhoto.entityType === ENTITY_TYPES.VENUE &&
        (entityPhoto.entityId === state.venue.id ||
          entityPhoto.entityTempId === state.venue.creationId)
      ) {
        const entityPhotos = state.entityPhotos.slice();
        entityPhotos.push(entityPhoto);

        return {
          ...state,
          entityPhotos: entityPhotos
        };
      } else {
        result = state;
      }
      return result;
    }

    case actionTypes.DELETE_ENTITY_PHOTO_FULFILLED: {
      const entityPhoto = action.payload.data.result;
      let result;

      if (
        entityPhoto.entityType === ENTITY_TYPES.VENUE &&
        (entityPhoto.entityId === state.venue.id ||
          entityPhoto.entityTempId === state.venue.creationId)
      ) {
        const photoIndex = state.entityPhotos
          .map(photo => photo.id)
          .indexOf(entityPhoto.id);

        const entityPhotos = state.entityPhotos.slice();
        entityPhotos.splice(photoIndex, 1);

        return {
          ...state,
          entityPhotos: entityPhotos
        };
      } else {
        result = state;
      }
      return result;
    }

    case actionTypes.SAVE_ENTITY_PHOTO_FULFILLED: {
      const entityPhoto = action.payload.data.result;
      let result;

      if (
        entityPhoto.entityType === ENTITY_TYPES.VENUE &&
        (entityPhoto.entityId === state.venue.id ||
          entityPhoto.entityTempId === state.venue.creationId)
      ) {
        const photoIndex = state.entityPhotos
          .map(photo => photo.id)
          .indexOf(entityPhoto.id);

        const entityPhotos = state.entityPhotos.slice();
        entityPhotos[photoIndex] = action.payload.data.result;

        return {
          ...state,
          entityPhotos: entityPhotos
        };
      } else {
        result = state;
      }
      return result;
    }

    case actionTypes.FIND_ENTITY_PHOTOS_FULFILLED: {
      return {
        ...state,
        venueLoading: false,
        entityPhotos: action.payload.data.result
      };
    }

    case actionTypes.ADD_VENUE_AUTHORIZED_DOMAIN: {
      const domains = state.venue.authorizedPortalEmailDomains
        ? state.venue.authorizedPortalEmailDomains.slice()
        : [];
      domains.push('');
      return {
        ...state,
        venue: {
          ...state.venue,
          authorizedPortalEmailDomains: domains
        }
      };
    }

    case actionTypes.REMOVE_VENUE_AUTHORIZED_DOMAIN: {
      const domains = state.venue.authorizedPortalEmailDomains.slice();
      const index = action.payload;
      domains.splice(index, 1);
      return {
        ...state,
        venue: {
          ...state.venue,
          authorizedPortalEmailDomains: domains
        }
      };
    }

    case actionTypes.SET_VENUE_AUTHORIZED_DOMAIN_VALUE: {
      const domains = state.venue.authorizedPortalEmailDomains.slice();
      const { value, index } = action.payload;
      domains[index] = value;
      return {
        ...state,
        venue: {
          ...state.venue,
          authorizedPortalEmailDomains: domains
        }
      };
    }

    case actionTypes.ADD_VENUE_INTEGRATION_PARTNER_IDENTIFIER: {
      const identifiers = state.venue.integrationPartnerIdentifiers
        ? state.venue.integrationPartnerIdentifiers.slice()
        : [];
      identifiers.push({ id: '', partner: null });
      return {
        ...state,
        venue: {
          ...state.venue,
          integrationPartnerIdentifiers: identifiers
        }
      };
    }

    case actionTypes.REMOVE_VENUE_INTEGRATION_PARTNER_IDENTIFIER: {
      const identifiers = state.venue.integrationPartnerIdentifiers.slice();
      const index = action.payload;
      identifiers.splice(index, 1);
      return {
        ...state,
        venue: {
          ...state.venue,
          integrationPartnerIdentifiers: identifiers
        }
      };
    }

    case actionTypes.SET_VENUE_INTEGRATION_PARTNER_IDENTIFIER_VALUE: {
      const identifiers = state.venue.integrationPartnerIdentifiers.slice();
      const { field, value, index } = action.payload;
      identifiers[index] = { ...identifiers[index], [field]: value };
      return {
        ...state,
        venue: {
          ...state.venue,
          integrationPartnerIdentifiers: identifiers
        }
      };
    }

    default: {
      return state;
    }
  }
};

export default venueCreateReducer;
